<p-toast></p-toast>
<div class="flex h-screen">
  <!-- Sidebar Menu - Only show when not on login page -->
  <app-sidebar-menu *ngIf="!isLoginPage"></app-sidebar-menu>

  <!-- Main Content - Full width on login page -->
  <div class="flex-1 overflow-scroll" [ngClass]="{'p-4': !isLoginPage}">
    <router-outlet></router-outlet>
  </div>
</div>
